import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest, PaginationType } from '../../types/pagination';
import { CustomCacheRequest, IdValue, SortRequest, WithArchiveRequest } from '../../types/props';
import { FormType } from './forms-api';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type TreeNodeType = {
  action_text: string;
  children?: Partial<TreeNodeType>[];
  deadline_minutes: string | null;
  fk_color: string;
  id: number | string;
  is_hot_access: boolean;
  is_leaf: boolean;
  is_hidden?: boolean;
  is_photo_required: boolean;
  is_callback?: boolean;
  meta: string[];
  name: LangType;
  notification_repeat_time: number;
  tags: IdValue[];
  collapsed?: boolean;
  form?: FormType;
  form_uuid?: string;
  images?: {
    main?: {
      thumbnail?: string;
    };
    other?: string[];
  };
};

export type TreeType = {
  id: number;
  name: LangType;
  is_deleted?: boolean;
  qr?: { id: string; value: LangType }[];
  description?: LangType;
  branches?: { id: string; value: LangType }[];
  nodes?: Partial<TreeNodeType>[];
};

export type FetchTreeListRequest = {
  name?: string;
  description?: string;
  branch?: string;
  qr?: string;
} & Omit<Partial<TreeType>, 'qr'> &
  PaginationRequest &
  SortRequest &
  CustomCacheRequest &
  WithArchiveRequest;

const baseUrl = `${managerApiUrl}/tree`;

export const putTree = async (params: Partial<TreeType>): Promise<TreeType> => {
  const response = await baseFetch(baseUrl + `/${params.id}`, {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};

export const postTree = async (params: Partial<TreeType>): Promise<TreeType> => {
  const response = await baseFetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

export const fetchTreeList = async (
  params: FetchTreeListRequest,
): Promise<PaginationType & { trees: TreeType[] }> => {
  const { customCache, ...other } = params;
  const response = await baseFetch(baseUrl + buildParams(other), { customCache });
  return response;
};

export const deleteTree = async (id: string): Promise<void> => {
  const response = await baseFetch(`${baseUrl}/${id}`, { method: 'DELETE' });
  return response;
};

export const fetchTree = async (id: string): Promise<TreeType> => {
  const response = await baseFetch(baseUrl + `/${id}`);
  return response;
};

export const restoreTree = async (id: string): Promise<void> => {
  const response = await baseFetch(`${baseUrl}/${id}/restore`, { method: 'POST' });
  return response;
};
